/**
 * Svelte action: click-and-drag horizontal scrolling for a scroll container.
 * Lets a horizontally-scrollable strip (nav pills) be dragged with a mouse on
 * devices without touch. Touch/trackpad scrolling keeps working natively.
 * Suppresses the click that would otherwise fire on the element you dragged from.
 *
 * Usage: <ul use:dragScroll> … </ul>
 */
export function dragScroll(node) {
  let down = false;
  let startX = 0;
  let startLeft = 0;
  let moved = false;

  function onDown(e) {
    if (e.button !== 0) return; // primary button only
    down = true;
    moved = false;
    startX = e.clientX;
    startLeft = node.scrollLeft;
    node.classList.add('grabbing');
  }

  function onMove(e) {
    if (!down) return;
    const dx = e.clientX - startX;
    if (Math.abs(dx) > 4) moved = true;
    node.scrollLeft = startLeft - dx;
  }

  function onUp() {
    if (!down) return;
    down = false;
    node.classList.remove('grabbing');
  }

  // Capture-phase click suppression: if the pointer moved (a drag), cancel the
  // click so dragging across a tab doesn't select it.
  function onClickCapture(e) {
    if (moved) {
      e.preventDefault();
      e.stopPropagation();
      moved = false;
    }
  }

  node.addEventListener('mousedown', onDown);
  window.addEventListener('mousemove', onMove);
  window.addEventListener('mouseup', onUp);
  node.addEventListener('click', onClickCapture, true);

  return {
    destroy() {
      node.removeEventListener('mousedown', onDown);
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
      node.removeEventListener('click', onClickCapture, true);
    },
  };
}
